import { ReportTableColumnInterface } from '../interfaces/report-table-column.interface';
import { DataHeader } from '@spa/reporting';

export class ReportTableColumn extends DataHeader {
    constructor(data: ReportTableColumnInterface) {
        super(data);
    }
}
